import React from 'react'

const LocationMarketplace = () => {
    return (
        <div></div>
    )
}

export default LocationMarketplace